import Api from '@/services/Api'
export default {
  AddParcel (position,data,admin) {
    return new Promise((resolve, reject) => {
      Api()
        .post('/Home/addparcel', {polygon: position,data:data,id_admin:admin},{headers: {
          "Access-Control-Allow-Origin": "*",}})
        .then(res => {
          // if (res.status == 200 && !isEmpty(res.data) && isEmpty(res.data.err))
          // {
            // console.log(res.data);
            // localStorage.setItem('authToken', res.data.token);
            // localStorage.setItem('Type', res.data.type);
            // localStorage.setItem('Logo', res.data.logo);
            resolve(res.data);
          // }
          // else
          //   reject('Error Try Again')
        })
        .catch(err => reject(err))
    })
  },
   getParcel() {
    return new Promise((resolve, reject) => {
      Api()
      .post('/Home/getParcel',{id_admin:localStorage.getItem("authToken")})
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
    })
  },

}